<template>
  <el-popover v-model="visible" placement="top" :title="title" :trigger="triggerMethod">
    <div class="content-wrapper">
      <div class="editable-cell" :style="styles">
        <!-- 自定义插槽内容 -->
        <slot v-if="$slots.default"></slot>

        <!-- 默认修改input -->
        <div v-else class="editable-cell-input">
          <el-input v-model="bidValue" @keyup.enter.native="save" />
        </div>
      </div>
      <div class="editable-cell-btns">
        <el-button type="text" :loading="loading" @click="save">
          {{ loading ? '' : '保存' }}
        </el-button>
        <el-button type="text" @click="closePopover">取消</el-button>
      </div>
    </div>
    <div slot="reference" class="poper-cell-reference">
      <slot name="reserve-icon"></slot>
      <el-button v-if="text" type="text" @click="showPopover"> {{ text }} </el-button>
      <el-button v-else type="text">-</el-button>
    </div>
  </el-popover>
</template>
<script>
/**
 * @description: table cell 数据编辑浮层
 * @usage: 默认为基础的数据修改input
 * @usage: 可以使用自定义插槽
 */
export default {
  name: 'EditableCell',
  props: {
    title: {
      type: String
    },
    text: {
      type: [String, Number],
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    width: {
      type: [String, Number]
    }
  },
  computed: {
    styles() {
      return this.width ? { width: `${this.width}px` } : {}
    },

    triggerMethod() {
      const text = Number(this.text)
      // 利用popover的trigger属性，达到两个目的：
      // 1、manual: 如果text不是正的数值，那么使用manual触发，但是又没有this.visible = true的行为，达到为0的cell不显示popover的目的
      // 2、click: 点击一个cell会自动隐藏已打开的其他popover的特性
      // return !Object.is(text, NaN) && text > 0 ? 'click' : 'manual'

      // 天工v4.35修改，为-的时候点击不触发
      return this.text === '-' ? 'manual' : 'click'
    }
  },
  data() {
    return {
      visible: false,
      bidValue: this.text
    }
  },
  watch: {
    text() {
      this.bidValue = this.text
    }
  },
  methods: {
    save() {
      this.$emit('save', this.bidValue)

      setTimeout(() => {
        this.closePopover()
      }, 500)
    },
    closePopover() {
      this.visible = false
      this.bidValue = this.text
    },
    showPopover() {
      if (this.triggerMethod === 'click') {
        this.$emit('change')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.content-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .editable-cell {
    .editable-cell-input {
      width: 80px;
    }
  }

  .editable-cell-btns {
    display: flex;
    flex: 1;
    button {
      margin-left: 6px;
    }
  }
}

.poper-cell-reference {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
